<div class="editRoles__container">
  <div class="editRoles__header">
    <div class="editRoles__title">
      {{ isRoleEdit ? "Edit role" : "Add Role" }}
    </div>
    <div (click)="handleOnClickClose()" class="editRoles__crossIcon">
      <img
        src="../../../../assets/Images/organisation-structure/Cross.svg"
        alt="cross icon"
        />
      </div>
    </div>
    <div class="editRoles__contentWrapper">
      <div class="editRoles__form">
        <app-input-filed
          placeholder="Enter role"
          label="Role Name"
          [control]="roleName"
          name="roleName"
          [starIcon]="'*'"
        ></app-input-filed>
      </div>
      @if (roleName.invalid && (roleName.dirty || roleName.touched)) {
        <div>
          @if (roleName.errors?.['required']) {
            <small
              class="text-danger"
              style="margin-left: 12px"
              >
              Please Enter the role name</small
              >
          }
        </div>
      }
      @if (roleName.errors?.['pattern']) {
        <div>
          <small class="text-danger" style="margin-left: 12px" >First letter must be alphabet allowed 3-15 characters only</small>
        </div>
      }
      <div class="editRoles__cardHeader">Role permissions</div>

      @for (
        permission of permissionList; track
        permission; let index = $index; let last = $last) {
        <div [ngClass]="last ? 'no-border' : 'editRoles__cardContainer'">
          <div class="editRolesCard__container">
            <div class="editRolesCard__image">
              <div class="editRolesCard__icon">
                <img
                src="{{
                  permission.icon ||
                    '../../../assets/Images/roles-responsibilities/dashboard-small.svg'
                }}"
                  alt="icon"
                  />
                </div>
                <div class="editRolesCard__iconTitle">{{ permission.label }}</div>
              </div>
              <div class="editRolesCard__content">
                <div class="custom-radio">
                  <label class="container">
                    <div >
                      @switch (permission.module) {
                        @case ('company-contacts') {
                          <div class="radiobutton__text">
                            View
                          </div>
                        }
                        @case ('e-sign-details') {
                          <div class="radiobutton__text">
                            Yes
                          </div>
                        }
                        @default {
                          <div class="radiobutton__text">
                            Full
                          </div>
                        }
                      }
                    </div>
                    <input
                      type="radio"
                      [value]="'full'"
                      name="radioButton1{{ index }}"
                      id="radio1{{ index }}"
                      (change)="changeSelection($event, index, permission)"
                      [checked]="permission.enabled"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                  @if (permission.subPermissions) {
                    <div class="custom-radio">
                      <label class="container">
                        <div class="radiobutton__text">Some</div>
                        <input
                          type="radio"
                          [value]="'some'"
                          name="radioButton1{{ index }}"
                          id="radio2{{ index }}"
                          (change)="changeSelection($event, index, permission)"
                  [checked]="
                    permission.some &&
                    permission.some != 'Active' &&
                    !!permission.subPermissions
                  "
                          />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    }
                    <div class="custom-radio">
                      <label class="container">
                        <div >
                          @switch (permission.module) {
                            @case ('company-contacts') {
                              <div class="radiobutton__text">
                                None
                              </div>
                            }
                            @case ('e-sign-details') {
                              <div class="radiobutton__text">
                                No
                              </div>
                            }
                            @default {
                              <div class="radiobutton__text">
                                None
                              </div>
                            }
                          }
                        </div>
                        <input
                          type="radio"
                          [value]="'none'"
                          name="radioButton1{{ index }}"
                          id="radio3{{ index }}"
                          (change)="changeSelection($event, index, permission)"
                          [checked]="!permission.enabled && permission.some == 'Active'"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                      @for (value of permission.subPermissions | keyvalue; track value) {
                        @if (permission.isShow) {
                          <app-checkbox
                            (checked)="handleSubPermissionChange($event, index)"
                            checkboxStatus="{{ value.value }}"
                            checkBoxKey="{{ value.key }}"
                  checkBoxName="{{
                    getPermissionMappingName(permission, value.key)
                  }}"
                          ></app-checkbox>
                        }
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
            <div class="editRoles__footer">
              @if (errorMsg) {
                <small class="text-danger">{{ errorMsg }}</small>
              }
              <app-common-button
                buttonClass="smallbutton"
                buttonLabel="Cancel"
                (clickEvent)="closePanel.emit(false)"
              ></app-common-button>
              @if (commonService.orgLock()) {
                <div>
                  <app-common-button
                    appAccessControl
                    allowedRoles="{{roleId ? 'role.edit' : 'role.create'}}"
                    buttonClass="smallFilledButton"
                    buttonLabel="{{roleId ? 'Update' : 'Save'}}"
                    [disabled]="isValid || isEnable "
                    (clickEvent)="createRole()"
                    [loadingIcon]="verifyLoader"
                  ></app-common-button>
                </div>
              }
            </div>
          </div>
